<div class="rooms-container">
  @if (loading) {
    <div class="loading-container"><app-loading></app-loading></div>
  }
  <div class="room-container">
    @if (!rooms.length && !this.loading && scootaverseId) {
      <no-rooms-page [scootaverseId]="scootaverseId"></no-rooms-page>
    } @else {
      <div class="room-list">
        <div class="room-card">
          @if (!this.loading && scootaverseId) {
            <create-room [scootaverseId]="scootaverseId"></create-room>
          }
        </div>
        @for (room of rooms; track trackByRoomId($index, room)) {
          <div class="room-card">
            <room-info-preview
              [roomName]="room.name"
              [playlistId]="room.playlistId"
              [theme]="room.theme"
              [roomSizeInfo]="getRoomSizeByCapacity(room)"
              [isRoomListPage]="true"
              [room]="room"
              [scootaverseId]="scootaverseId ?? ''"
              (loadingEnterRoom)="setLoading($event)"
            ></room-info-preview>
          </div>
        }
      </div>
    }
  </div>
</div>
